module.exports = __webpack_public_path__ + "img/kaeya.9e0ead5a.webp";